import sgImgS1 from '../images/service-single/graphics/img-1.jpg'
import sgImgS2 from '../images/service-single/graphics/img-2.jpg'
import sgImgS3 from '../images/service-single/graphics/img-3.jpg'

import brImgS1 from '../images/service-single/brand/img-1.jpg'
import brImgS2 from '../images/service-single/brand/img-2.jpg'
import brImgS3 from '../images/service-single/brand/img-3.jpg'

import uxImgS1 from '../images/service-single/ux/img-1.jpg'
import uxImgS2 from '../images/service-single/ux/img-2.jpg'
import uxImgS3 from '../images/service-single/ux/img-3.jpg'

import dvImgS1 from '../images/service-single/development/img-1.jpg'
import dvImgS2 from '../images/service-single/development/img-2.jpg'
import dvImgS3 from '../images/service-single/development/img-3.jpg'

import adImgS1 from '../images/service-single/app/img-1.jpg'
import adImgS2 from '../images/service-single/app/img-2.jpg'
import adImgS3 from '../images/service-single/app/img-3.jpg'

import swImgS1 from '../images/service-single/softwere/img-1.jpg'
import swImgS2 from '../images/service-single/softwere/img-2.jpg'
import swImgS3 from '../images/service-single/softwere/img-3.jpg'

import smImgS1 from '../images/service-single/sm/img-1.jpg'
import smImgS2 from '../images/service-single/sm/img-2.jpg'
import smImgS3 from '../images/service-single/sm/img-3.jpg'

import dmImgS1 from '../images/service-single/dm/img-1.jpg'
import dmImgS2 from '../images/service-single/dm/img-2.jpg'
import dmImgS3 from '../images/service-single/dm/img-3.jpg'

import emailImgS1 from '../images/service-single/email/img-1.jpg'
import emailImgS2 from '../images/service-single/email/img-2.jpg'
import emailImgS3 from '../images/service-single/email/img-3.jpg'



const Services = [
    {
        Id: '1',
        sImgS:sgImgS1,
        sTitle: 'Graphic Design',
        description:'Bringing creativity and clarity together to craft visuals that communicate and inspire.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'flaticon-vector',
        ssImg1:sgImgS2,
        ssImg2:sgImgS3,
    },
    {
        Id: '2',
        sImgS:brImgS1,
        sTitle: 'Brand Identity',
        description:'Design unique brand identities that capture your vision and connect with your audience',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'flaticon-palette',
        ssImg1:brImgS2,
        ssImg2:brImgS3,
    },
    {
        Id: '3',
        sImgS:uxImgS1,
        sTitle: 'UI/UX Design',
        description:'Creating intuitive and engaging user experiences with clean, modern interfaces.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'flaticon-add',
        ssImg1:uxImgS2,
        ssImg2:uxImgS3,
    },
    {
        Id: '4',
        sImgS:dvImgS1,
        sTitle: 'Web Development',
        description:'Building modern, responsive websites that deliver seamless user experiences.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'flaticon-coding',
        ssImg1:dvImgS2,
        ssImg2:dvImgS3,
    },
    {
        Id: '5',
        sImgS:adImgS1,
        sTitle: 'App Development',
        description:'Design and developing user-friendly mobile apps that deliver smooth performance.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'flaticon-app-development',
        ssImg1:adImgS2,
        ssImg2:adImgS3,
    },
    {
        Id: '6',
        sImgS:swImgS1,
        sTitle: 'Softwere Development',
        description:'Building reliable and efficient software solutions tailored to your business needs.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'flaticon-smartphone',
        ssImg1:swImgS2,
        ssImg2:swImgS3,
    },
    {
        Id: '7',
        sImgS:smImgS1,
        sTitle: 'Social Media Marketing',
        description:'Boosting your brand’s online presence with creative content and smart engagement strategies.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'flaticon-social-media',
        ssImg1:smImgS2,
        ssImg2:smImgS3,
    },
    {
        Id: '8',
        sImgS:dmImgS1,
        sTitle: 'Digital Marketing',
        description:'Driving growth through targeted campaigns, SEO, and creative online strategies.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'flaticon-promotion',
        ssImg1:dmImgS2,
        ssImg2:dmImgS3,
    },
    {
        Id: '9',
        sImgS:emailImgS1,
        sTitle: 'Email Marketing',
        description:'Connecting with your audience through personalized, engaging, and result-driven emails.',
        des2:'Lacus, etiam sed est eu tempus need Temer diam congue laoret .',
        des3:'One way to categorize the activities is in terms of the professional’s area of expertise such as competitive analysis, corporate strategy the activities',
        icon:'flaticon-email-marketing',
        ssImg1:emailImgS2,
        ssImg2:emailImgS3,
    },
]    

export default Services;